import { io } from "socket.io-client";

const socket = io("https://api.dothink.ai", {
  withCredentials: true,
  transports: ["websocket"],
});

export default socket;